import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';

export default class DeluxePlayerControlsComponent extends Component {
  @service stereo;
  @service feeds;

  static REWIND_MS = 10000;
  static FORWARD_MS = 15000;

  // A live broadcast is never scrubbed in place, so stepping back means rewinding into its recording.
  @action
  rewind() {
    let feed = this.args.feed;
    if (feed?.isLiveEdge) {
      let position = Math.max(feed.elapsedMs - DeluxePlayerControlsComponent.REWIND_MS, 0);
      this.feeds.scrubToFeed(feed.airing, position);
      return;
    }
    feed?.seek(Math.max((feed.playheadPositionMs ?? 0) - DeluxePlayerControlsComponent.REWIND_MS, 0));
  }

  @action
  fastForward() {
    let feed = this.args.feed;
    feed?.seekOrGoLive((feed.playheadPositionMs ?? 0) + DeluxePlayerControlsComponent.FORWARD_MS);
  }

  @action
  goLive() {
    this.feeds.goLive();
  }
}
